export default {"src":"/_next/static/media/assistant-cook-with-medium-green-text-box.90d0a612.svg","height":378,"width":301};